<div class="month-container d-flex justify-content-center">
    <span class="text-uppercase fw-bold">{{ date | date:'MMM' }}</span>
</div>

<div class="day-year-container d-flex flex-column justify-content-center align-items-center flex-1">
    <span class="day-text">{{ date | date:'dd' }}</span>
    <span class="year-text">{{ date | date:'yyyy' }}</span>
</div>